
import { Link } from "react-router-dom";

const NotFound = () => (
  <>
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800">404 - Page Not Found</h1>
        <p className="text-xl text-gray-600 mt-4 mb-8">
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </p>
        <Link to="/">
          <a className="text-blue-500 hover:underline">Go back </a>
        </Link>
      </div>
    </div>
  </>
);

export default NotFound;
